import initReducer from '../lib/init-reducer'
import initialState from './initial-states/sections'
export default initReducer(initialState, {
    SET_ABOUT_VISIBILITY: (state, action) => ({ ...state, about: {
        ...state.about, isVisible: action.value
    }}),
    SET_SECTION_VISIBILITY: (state, { section, isVisible }) => ({ ...state, [section]: {
        ...state[section], isVisible
    }}),
    SET_PARTICLE_VISIBILITY: (state, action) => ({ ...state, [action.section]: {
      ...state[action.section], [action.config]: action.visible
    }}),
    SET_SECTION_PROPERTY: (state, action) => ({ ...state, [action.section]: {
        ...state[action.section], [action.config]: action.value
    }})
})


// WEBPACK FOOTER //
// ./src/reducers/SectionsReducer.js